// extracted by mini-css-extract-plugin
module.exports = {"divContent":"totalsImportDoc_divContent__VOVyB","labelTitle":"totalsImportDoc_labelTitle__20QeT"};